module.exports = __webpack_public_path__ + "media/images/pic/saska/hero-kids-d2e6926aaacd8b9ffa4a833360302ec0.png";